import { forwardRef } from 'react'
import { Callout, InfoCircle, Input } from '@dashboard/ui'

interface FormTypeFontFamilyControlProps {
  value: string
  onChange: (value: string) => void
}

export const FormTypeFontFamilyControl = forwardRef<HTMLInputElement, FormTypeFontFamilyControlProps>(function (
  { value, onChange },
  ref,
) {
  return (
    <div className="rounded-md border bg-fg-secondary">
      <div className="flex justify-between p-3">
        <div className="font-medium text-text-secondary">Font Family</div>
      </div>

      <div className="flex flex-col gap-3 border-t p-3">
        <Callout variant="danger" label="Only Google Fonts are supported" icon={InfoCircle}>
          <div className="flex flex-col gap-1.5">
            <p>Fonts with weights from 300 to 700 inclusive are supported.</p>
            <p>Specify only the font name without weight, example: 'Noto Sans'</p>
          </div>
        </Callout>

        <Input ref={ref} value={value} onChange={e => onChange(e.target.value)} />
      </div>
    </div>
  )
})
